import { render, staticRenderFns } from "./Sit.vue?vue&type=template&id=3512c7e9&scoped=true&"
import script from "./Sit.vue?vue&type=script&lang=js&"
export * from "./Sit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512c7e9",
  null
  
)

export default component.exports